"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _date = require("@/utils/date");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _MenuFoodDialog = _interopRequireDefault(require("./MenuFoodDialog"));
var food = _interopRequireWildcard(require("@/api/menu-food"));
var _format = require("@/utils/format");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    MenuFoodDialog: _MenuFoodDialog.default
  },
  props: {
    storeId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      listLoading: false,
      total: 0,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      listQuery: {
        page: 1,
        limit: 10,
        search: "",
        isBlock: null
      }
    };
  },
  watch: {
    storeId: function storeId() {
      this.getTableData();
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    tableData: function tableData(state) {
      return state.menuFood.list;
    }
  })),
  methods: {
    formatCurrency: function formatCurrency(n) {
      return (0, _format.formatCurrency)(n);
    },
    handleEdit: function handleEdit(row) {
      this.$refs["dialog"].handleEdit(row);
    },
    handleAdd: function handleAdd() {
      this.$refs["dialog"].handleAdd();
    },
    handleImgError: function handleImgError(event) {
      event.currentTarget.src = require("@/assets/images/avatar_default.svg");
    },
    handleBlock: function handleBlock(row) {
      var _this = this;
      this.$confirm("Danh mục này sẽ bị xóa, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        food.remove(row.id).then(function () {
          row.isBlock = true;
          _this.$message({
            type: "success",
            message: "Xóa thành công"
          });
          _this.getTableData();
        });
      });
    },
    getTableData: function () {
      var _getTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.listLoading = true;
              this.listQuery.storeId = this.storeId;
              _context.next = 4;
              return this.$store.dispatch("menuFood/fetchList", this.listQuery);
            case 4:
              this.total = _context.sent;
              this.listLoading = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }(),
    formatDateTime: function formatDateTime(timestamp) {
      return (0, _date.formatDateTime)(timestamp);
    },
    editData: function editData(row) {
      var _this2 = this;
      var data = {
        menuFood: {
          no: row.no
        }
      };
      food.update(row.id, data).then(function (res) {
        _this2.getTableData();
      });
    }
  }
};